module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPlJREFUWEftldENwjAQQ90JYANgAliJzdgERmADGIERkKWAQrjUDabqTyr1y+3dO+fcDlj4Ghbujw7QHegOTHVgC4D3pRJbpVfTPhXgAWAF4AjgFFRTug1wBbBPVSIIpdsA62R/DULpNgALsAkn3VScUHoIMXUHXi8fkhPcB17lcSj9C6IVgAVUE6V/QPwCEEHsANyzyiVEqb8fdQDOaS9YLAIY0y0ATpcXj/ZgTLeO4K/NSdJyBIzZLbO9nFzpVgxZnLbSgSh+Src/ROpTq3QLgNMxYrWfkdKrzVt2QP1ulW45MDqBK7akwO1lpWCW5i070AG6A7M58ARvhTwhOM7veQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page_next_icon.png
// module id = wCPc
// module chunks = 3